/**
 * 통합 홈페이지 컴포넌트 (반응형)
 * 메인 배너, 서비스 안내, 문의 정보, 공지사항/포토갤러리 탭을 표시합니다.
 * 데스크톱과 모바일 모두에서 사용 가능한 반응형 컴포넌트입니다.
 */

import styled from 'styled-components';
import { useIsDesktop } from '../hooks/useMediaQuery';
import MyHelmet from '../hooks/Helmet';

// 홈페이지 섹션 컴포넌트
import HeroBanner from '../components/home/HeroBanner';
import ServiceQuickSection from '../components/home/ServiceQuickSection';
import ServiceContactSection from '../components/home/ServiceContactSection';
import DesktopTabBoard from '../components/home/DesktopTabBoard';
import MobileBoardList from '../components/home/MobileBoardList';
import PhotoGallerySection from '../components/home/PhotoGallerySection';

/**
 * HomePage 컴포넌트
 * 메인 페이지의 전체 레이아웃과 콘텐츠를 관리합니다.
 */
function HomePage() {
  const isDesktop = useIsDesktop();

  return (
    <>
      <MyHelmet />
      {/* 메인 배너 */}
      <HeroBanner />

      {/* 메인 콘텐츠 */}
      <MainContainer>
        {/* 서비스 안내 및 문의 섹션 */}
        <TopSection>
          <ServiceQuickSection />
          <ServiceContactSection />
        </TopSection>

        {/* 게시판 및 포토갤러리 섹션 */}
        <BottomSection>
          {/* 데스크톱: 탭 게시판, 모바일: 둘 다 펼쳐진 게시판 */}
          {isDesktop ? <DesktopTabBoard /> : <MobileBoardList />}

          {/* 포토갤러리 */}
          <PhotoGallerySection />
        </BottomSection>
      </MainContainer>
      <hr />
    </>
  );
}

export default HomePage;

/* Styled Components */

const MainContainer = styled.div`
  /* 데스크톱 기본 스타일 */
  position: relative;
  width: 100%;
  max-width: 1020px;
  margin: 0 auto;
  min-height: 570px;
  height: auto;
  background: #fff;
  padding-bottom: 25px;

  &::after {
    display: block;
    clear: both;
    content: '';
  }

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    max-width: 100%;
    min-height: auto;
  }
`;

const TopSection = styled.div`
  /* 데스크톱 기본 스타일 */
  position: relative;
  width: 100%;
  min-height: 230px;
  margin-top: 25px;
  display: flex;
  gap: 0;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    flex-direction: column;
    margin-top: 0;
    gap: 0;
  }
`;

const BottomSection = styled.div`
  /* 데스크톱 기본 스타일 */
  width: 100%;
  min-height: 228px;
  margin-top: 25px;
  font-family: 'Nanum Gothic Bold';
  display: flex;
  gap: 0;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    height: auto;
    margin-top: 0;
    flex-direction: column;
    gap: 0;
  }
`;
